module.exports = __webpack_public_path__ + "media/application/images/svgs/icon_bullet-7a88baaae8f2a04637c63ed4ef20a1cd.svg";